// v3/design-system/primitives/textarea.tsx — Textarea primitive
// Shadcn/UI pattern: forwardRef, cn() merging, 44px min touch target.
// Zero imports from v1/v2.

import * as React from 'react';

import { cn } from '../utils';

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<'textarea'>
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        'flex min-h-[80px] w-full rounded-[var(--shape-control)] border border-input bg-card px-3 py-2 text-base ring-offset-background transition-[border-color,box-shadow] duration-fast placeholder:text-muted-foreground hover:border-[var(--m-muted)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        props['aria-invalid'] && 'border-[var(--ch-danger-fg)] focus-visible:ring-[var(--ch-danger-fg)]',
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = 'Textarea';

export { Textarea };
